// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3cwJK","productName":"Table_productName__2xzkJ"};